module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.woff2?2d89b49ac28614e9ccd9c81308b5120c";